import { useMedia } from './useMedia';

const DESKTOP_BLUR = 2;
const MOBILE_BLUR = 1;

export const useShowMore = (
    hasMoreTrips: boolean,
    isLoading: boolean,
    showLen: number,
    fullLen?: number
) => {
    const isDesktop = useMedia('(min-width: 992px)');

    const showMoreTours = hasMoreTrips && !isLoading;
    const lastItems = isDesktop ? DESKTOP_BLUR : MOBILE_BLUR;
    const lastAvailIndex = showMoreTours ? showLen - lastItems : 0;
    const count = fullLen ? `${fullLen - showLen}+ ` : '';
    const showMoreText = `Show ${count} more tours & activities`;

    const isLastItem = (index: number) => !!lastAvailIndex && lastAvailIndex < index + 1;

    return {
        showMoreTours,
        showMoreText,
        isLastItem,
    };
};
